"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlayIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PlayIcon() {
  return _react2.default.createElement("svg", {
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react2.default.createElement("title", null, "play"), _react2.default.createElement("desc", null, "Created with Sketch."), _react2.default.createElement("defs", null), _react2.default.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("g", {
    id: "play",
    fill: "#01B6F5",
    fillRule: "nonzero"
  }, _react2.default.createElement("path", {
    d: "M16.545809,8.37037037 L2.82261209,0.257309942 C1.70760234,-0.401559454 0,0.237816764 0,1.86744639 L0,18.0896686 C0,19.5516569 1.58674464,20.4327485 2.82261209,19.6998051 L16.545809,11.5906433 C17.7699805,10.8693957 17.7738791,9.09161793 16.545809,8.37037037 Z",
    id: "Shape"
  }))));
}